import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'demo_access_granted';
const USERNAME = 'demo';
const PASSWORD = 'demo123';

export default function DemoGate({ children }) {
  const [granted, setGranted] = useState(false);
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    try {
      const val = localStorage.getItem(STORAGE_KEY);
      if (val === 'true') setGranted(true);
    } catch {}
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    if (user.trim().toLowerCase() === USERNAME && pass === PASSWORD) {
      try { localStorage.setItem(STORAGE_KEY, 'true'); } catch {}
      setGranted(true);
    } else {
      setError('Credențiale invalide. Te rog încearcă din nou.');
    }
  };

  if (granted) return children;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', paddingTop: '80px', padding: '80px 20px 20px' }}>
      {/* Preserve existing top bar by not altering layout outside App */}
      <form onSubmit={onSubmit} style={{ maxWidth: 400, width: '100%', background: '#ffffff', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', borderRadius: 12, padding: '24px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <h2 style={{ marginTop: 0, marginBottom: 8, alignSelf: 'flex-start' }}>Acces Demo</h2>
        <p style={{ marginTop: 0, color: '#444', marginBottom: 16, alignSelf: 'flex-start' }}>
          Pentru a vizualiza demo-ul, te rog introdu credențialele.
        </p>
        <label style={{ display: 'block', fontWeight: 600, marginBottom: 6, alignSelf: 'flex-start' }}>Utilizator</label>
        <input
          type="text"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          style={{ width: '60%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ccc', marginBottom: 12, alignSelf: 'flex-start' }}
        />
        <label style={{ display: 'block', fontWeight: 600, marginBottom: 6, alignSelf: 'flex-start' }}>Parolă</label>
        <input
          type="password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          style={{ width: '60%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ccc', marginBottom: 12, alignSelf: 'flex-start' }}
        />
        {error && <div style={{ color: '#b00020', marginBottom: 12, alignSelf: 'flex-start' }}>{error}</div>}
        <button type="submit" style={{ width: '60%', background: '#0d6efd', color: '#fff', border: 'none', padding: '10px 12px', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
          Intră în demo
        </button>
        {/* No credential hint shown for privacy */}
      </form>
    </div>
  );
}
